{
  "as_field": "Как",
  "behavior_create_only": "Только создать новые записи",
  "behavior_create_only_caption": "Игнорировать строки, которые соответствуют существующим записям",
  "behavior_update_only": "Только обновить существующие записи",
  "behavior_update_only_caption": "Пропустить строки, которые не соответствуют существующим записям",
  "behavior_upsert": "Обновить существующие и создать новые записи",
  "behavior_upsert_caption": "Обновить совпадающие записи и создать новые для остальных",
  "check_data_matching": "Проверьте сопоставление данных",
  "check_data_matching_caption": "Мы автоматически сопоставили столбцы. Проверьте и скорректируйте при необходимости.",
  "check_before_you_continue": "Проверьте перед продолжением",
  "common_settings_caption": "Выберите, куда импортировать данные и как обновлять совпадающие записи.",
  "custom_tables_setup": "Требуется сопоставление",
  "custom_tables_setup_title": "Конфигурация настраиваемых таблиц",
  "custom_tables_setup_caption": "Для каждой настраиваемой таблицы необходимо выбрать хотя бы один ключевой идентификатор",
  "identify_by": "идентифицировать по",
  "choose_fallback_currency": "    Мы не смогли определить валюту для некоторых записей. Выберите валюту по умолчанию, которая будет применена к этим записям",
  "choose_behaviour": "Выберите поведение",
  "choose_salary_period": "Выберите период для \"Компенсации\"",
  "count_columns_imported": "{columns} будет импортировано",
  "create_new_import": "Создать новый импорт",
  "create_new_values": "Создать новые",
  "create_new_values_caption": "Будут созданы новые значения",
  "current_value": "Текущее значение",
  "destination_in": "Назначение в %APP_NAME%",
  "empty_state_description": "Импортируйте данные из файла, чтобы быстро наполнить систему и начать работу",
  "empty_state_title": "Начните с первого импорта",
  "error_compensation_missing_effective_date": "Отсутствует дата вступления в силу для компенсации",
  "error_custom_table_missing_effective_date": "Отсутствует дата вступления в силу для пользовательской таблицы",
  "error_employee_already_exists": "Сотрудник уже существует",
  "error_employee_identifier_missing": "Отсутствует идентификатор сотрудника",
  "error_employee_not_found": "Сотрудник не найден",
  "error_employee_update_skipped": "Обновление сотрудника пропущено",
  "error_employment_missing_effective_date": "Отсутствует дата вступления в силу для трудоустройства",
  "error_invalid_data": "Некорректные данные",
  "error_position_missing_effective_date": "Отсутствует дата вступления в силу для должности",
  "error_required_fields_missing": "Отсутствуют обязательные поля",
  "exclude_column": "Исключить столбец",
  "exclude_field": "Исключить поле",
  "file_column": "Столбец файла",
  "file_info": "Информация о файле",
  "file_preview": "Превью файла",
  "file_uploaded_ready": "Файл загружен и готов к сопоставлению!",
  "found_columns": "Мы нашли {count_columns} в вашем файле. На следующем шаге вы сопоставите их с полями в системе",
  "how_data_matched": "Как сопоставлены данные",
  "how_to_handle_new_records": "Как обрабатывать новые записи",
  "how_to_handle_new_records_caption": "Выберите, что делать со строками, не соответствующими существующим записям",
  "how_to_match_records": "Как сопоставлять существующие записи",
  "how_to_match_records_caption": "Выберите, как мы идентифицируем существующих сотрудников или данные, связанные с отпусками",
  "default_update_method": "Метод обновления по умолчанию",
  "default_update_method_caption": "Выберите, как записывать значения, когда строка совпадает с существующей записью. Вы можете переопределить эту настройку для отдельных полей на следующем шаге",
  "update_only_if_empty": "Только если пусто",
  "update_only_if_empty_caption": "Заполнять только пустые поля",
  "update_always": "Всегда",
  "update_always_caption": "Заменять существующие значения данными из файла",
  "unrecognized_currencies": "Нераспознанные валюты",
  "unrecognized_currencies_substituted": "Нераспознанные валюты будут заменены на {currency}",
  "substitute_them_with": "Заменить их на",
  "destination": "Назначение",
  "destination_caption": "Выберите таблицу для импорта",
  "destination_table": "Таблица назначения",
  "download_template_title": "Скачать шаблон",
  "download_template_caption": "Заполните его, и ваши данные будут соответствовать формату %APP_NAME%",
  "import_complete": "Импорт завершён",
  "import_complete_caption": "Импорт данных запущен",
  "import_data": "Импортировать данные",
  "import_data_title": "Импорт данных",
  "import_data_to_system": "Импорт данных в систему",
  "import_errors": "Ошибки импорта",
  "import_in_progress": "Импорт выполняется",
  "import_in_progress_description": "Ваши данные загружаются в систему. Вы можете закрыть эту страницу — мы завершим процесс в фоновом режиме.",
  "import_mode": "Режим импорта",
  "import_processing_message": "Ваши данные обрабатываются. Вы можете проверить прогресс на странице импорта данных.",
  "import_started_successfully": "Импорт успешно запущен!",
  "import_to": "Импортировать в",
  "importing_to": "Импортируем в",
  "include_column": "Включить столбец",
  "include_field": "Включить поле",
  "and_others": "и другие",
  "invalid_values_warning": "Мы не смогли распознать {records}. Пример: {samples}",
  "invalid_values_for_field_type": "Обнаружены некорректные значения для типа поля",
  "invalid_values_found": "Обнаружены некорректные значения",
  "invalid_values_will_be_skipped": "Исправьте их в импортируемом файле или ничего не делайте — некорректные значения будут пропущены при импорте",
  "maps_to": "Сопоставлен с",
  "match_by": "Сопоставление по",
  "match_by_field": "Поле для сопоставления",
  "new_records": "Новые записи",
  "new_values_detected": "Обнаружены новые значения",
  "new_values_will_be_created": "Обнаружены новые значения, они будут созданы во время импорта",
  "new_values_will_be_skipped": "Обнаружены новые значения, они будут пропущены во время импорта",
  "new_value": "Новое значение",
  "new_value_in_directory": "Новое значение в справочнике",
  "no_data_found_in_file": "В файле не найдено данных для импорта",
  "match_summary": "Импортируем <strong>{import_type}</strong>, сопоставление по <strong>{match_by}</strong>. Мы будем <strong>{behavior}</strong>",
  "preset_choice_title": "Начать импорт",
  "preset_choice_caption": "Выберите данные, которые хотите импортировать",
  "preset_additional_compensation_create_caption": "Добавить новые записи дополнительных компенсаций для сотрудников",
  "preset_additional_compensation_create_title": "Добавить дополнительные компенсации",
  "preset_additional_compensation_update_caption": "Обновить существующие записи дополнительных компенсаций",
  "preset_additional_compensation_update_title": "Обновить дополнительные компенсации",
  "preset_compensation_create_caption": "Добавить новые записи компенсаций для сотрудников",
  "preset_compensation_create_title": "Добавить компенсации",
  "preset_compensation_update_caption": "Обновить существующие записи компенсаций",
  "preset_compensation_update_title": "Обновить компенсации",
  "preset_custom_table_create_caption": "Добавить новые записи в настраиваемые таблицы",
  "preset_custom_table_create_title": "Добавить записи в настраиваемые таблицы",
  "preset_custom_table_update_caption": "Обновить существующие записи настраиваемых таблиц",
  "preset_custom_table_update_title": "Обновить записи настраиваемых таблиц",
  "preset_employee_create_caption": "Добавить новых сотрудников в систему",
  "preset_employee_create_title": "Добавить сотрудников",
  "preset_employee_update_caption": "Обновить профили существующих сотрудников",
  "preset_employee_update_title": "Обновить сотрудников",
  "preset_employment_create_caption": "Добавить новые записи трудоустройства для сотрудников",
  "preset_employment_create_title": "Добавить трудоустройства",
  "preset_employment_update_caption": "Обновить существующие записи трудоустройства",
  "preset_employment_update_title": "Обновить трудоустройства",
  "preset_position_create_caption": "Добавить новые записи должностей для сотрудников",
  "preset_position_create_title": "Добавить должности",
  "preset_position_update_caption": "Обновить существующие записи должностей",
  "preset_position_update_title": "Обновить должности",
  "preset_time_off_balances_upsert_caption": "Добавьте суммы на балансы сотрудников по состоянию на начало текущего периода",
  "preset_time_off_balances_upsert_title": "Импортировать балансы",
  "preset_time_off_history_upsert_caption": "Добавить новые записи истории отсутствий",
  "preset_time_off_history_upsert_title": "Импортировать историю отсутствий",
  "preview_import": "Предпросмотр импорта",
  "ready_to_import": "Готово к импорту",
  "ready_to_import_caption": "Убедитесь, что всё выглядит правильно, прежде чем начать",
  "records": "Записей",
  "row_number": "Строка {number}",
  "rows_imported": "Импортировано строк",
  "samples": "Пример: {list}",
  "select_at_least_one_column": "Выберите хотя бы один столбец для импорта",
  "setup_field_type": "Настройте тип поля \"{field}\"",
  "skip_new_records": "Пропустить создание",
  "skip_new_records_caption": "Изменения будут проигнорированы",
  "update_as": "Обновлять",
  "update_mode": "Режим обновления",
  "updated_records": "Обновлённые записи",
  "upload_file_caption": "Вы можете импортировать данные в профили сотрудников или в систему отпусков",
  "upload_file_first": "Сначала загрузите файл",
  "upload_file_here": "Загрузите файл с данными сюда",
  "upload_file_title": "Загрузить файл",
  "values_dont_exist": "{values} не существует в \"{column}\"",
  "view_results": "Смотреть результаты",
  "wait_for_parsing": "Дождитесь результатов парсинга",
  "validation_error_add_field": "Для импорта \"{column}\" как \"{field}\" необходимо добавить {required_field}",
  "validation_error_missing_field": "Отсутствует обязательное поле: {field}"
}
